module.exports = __webpack_public_path__ + "nhome_icon.svg";